namespace uh.input {
    export class InputController {

        cursorKeys:Phaser.Types.Input.Keyboard.CursorKeys;

        scene:Phaser.Scene;
        constructor(scene:Phaser.Scene) {
            this.scene = scene;

            this.cursorKeys = this.scene.input.keyboard.createCursorKeys();

            this.cursorKeys.left.on('up', () => {this.cursorKeys.left['-used-'] = false;});
            this.cursorKeys.left['-used-'] = false;

            this.cursorKeys.right.on('up', () => {this.cursorKeys.right['-used-'] = false;});
            this.cursorKeys.right['-used-'] = false;

            this.scene.input.on("pointerup", ()=>{
                this._keyRightPressUsed = false;
                this._keyLeftPressUsed = false;
            });

            this.scene.input.keyboard.removeCapture([Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.RIGHT]);
        }

        public isLeftPressed():boolean {
            return this.scene.game.input.touch && this.scene.game.input.touch.enabled && this.scene.input.activePointer.isDown && this.scene.input.activePointer.x < this.scene.scale.width / 2
                || this.cursorKeys.left.isDown;
        }

        public isRightPressed():boolean {
            return this.scene.game.input.touch && this.scene.game.input.touch.enabled && this.scene.input.activePointer.isDown && this.scene.input.activePointer.x > this.scene.scale.width / 2
                || this.cursorKeys.right.isDown;
        }

        private _keyLeftPressUsed:boolean = false;
        public keyLeftPressedDownAndReleased():boolean {
            return this.cursorKeys.left.isDown && !this.cursorKeys.left['-used-']
                || this.isLeftPressed() && !this._keyLeftPressUsed;
        }
        public keyLeftPressUsed():void {
            this.cursorKeys.left['-used-'] = true;
            this._keyLeftPressUsed = true;
        }

        private _keyRightPressUsed:boolean = false;
        public keyRightPressedDownAndReleased():boolean {
            return this.cursorKeys.right.isDown && !this.cursorKeys.right['-used-']
                || this.isRightPressed() && !this._keyRightPressUsed;
        }
        public keyRightPressUsed():void {
            this.cursorKeys.right['-used-'] = true;
            this._keyRightPressUsed = true;
        }
    }
}